export default __webpack_public_path__ + "static/service-providers.url-4466a85f1fe4f1677ab94a26c16d5136.svg";